var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.Lead.info
    ? _c(
        "div",
        { staticClass: "DocumentTab" },
        [
          _vm.Documents.length
            ? _c(
                "div",
                [
                  _vm.isShowDocument
                    ? _c("show-document", {
                        attrs: { item: _vm.currentItem, file: _vm.currentItem },
                      })
                    : _c(
                        "table",
                        { staticClass: "table-basic documents-table" },
                        [
                          _c("tr", [
                            _c("th", [_vm._v("ID")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Title")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Notes")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Created at")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.Documents, function (document) {
                              return _c("tr", [
                                _c("td", { staticClass: "id-num" }, [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.getDocument(document)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(document.id))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(document.title))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(document.comments))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("moment")(
                                        document.created_at,
                                        "YYYY-MM-DD"
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                ],
                1
              )
            : _c("empty-info", { attrs: { icon: "/img/emptyIcon.png" } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }